import { render, staticRenderFns } from "./scoresTab.vue?vue&type=template&id=7a53d269&scoped=true&"
import script from "./scoresTab.vue?vue&type=script&lang=js&"
export * from "./scoresTab.vue?vue&type=script&lang=js&"
import style0 from "./scoresTab.vue?vue&type=style&index=0&id=7a53d269&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a53d269",
  null
  
)

export default component.exports